import classnames from 'classnames/bind'
import React from 'react'

import Cta, { CtaProps } from '~/components/Cta'
import Image, { ImageProps } from '~/components/Image'
import ImageWithPlaceholder, {
  ImageWithPlaceholderProps,
} from '~/components/ImageWithPlaceholder'
import Ratio from '~/components/Ratio'
import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const MOBILE_RATIO = 343 / 180
export interface BoxDoubleImageProps {
  className?: string
  image?: ImageWithPlaceholderProps
  logo?: ImageProps
  label?: RichTextBlock[]
  title?: RichTextBlock[]
  primaryCta?: CtaProps
  secondaryCta?: CtaProps
}

function BoxDoubleImage({
  className,
  image,
  logo,
  label,
  title,
  primaryCta,
  secondaryCta,
}: BoxDoubleImageProps) {
  const labelStyle = useStyle({
    textPreset: 'title-heading-5',
    color: 'blue-bayoux',
  })
  const titleStyle = useStyle({
    textPreset: 'title-body-content',
    color: 'cornflower-blue',
  })

  return (
    <div className={cx(css.BoxDoubleImage, className)}>
      <div className={css.boxContent}>
        <ImageWithPlaceholder
          className={cx(css.boxContentImage, css.hideOnSmallScreen)}
          layout="fill"
          objectFit="cover"
          {...image}
        />
        <Ratio
          ratio={MOBILE_RATIO}
          className={cx(css.boxContentImageWrapper, css.hideOnLargeScreen)}>
          {(cn) => (
            <ImageWithPlaceholder
              className={css.boxContentImage}
              layout="fill"
              objectFit="cover"
              {...image}
            />
          )}
        </Ratio>
        <div className={css.boxContentInfos}>
          <div className={css.boxContentInfosTop}>
            {label && (
              <RichText className={cx(css.label, labelStyle)} render={label} />
            )}
            {logo && (
              <>
                <ImageWithPlaceholder
                  layout="fill"
                  objectFit="contain"
                  objectPosition="right center"
                  className={cx(css.logo, css.hideOnSmallScreen)}
                  {...logo}
                />

                <ImageWithPlaceholder
                  layout="fill"
                  objectFit="contain"
                  objectPosition="left center"
                  className={cx(css.logo, css.hideOnLargeScreen)}
                  {...logo}
                />
              </>
            )}
          </div>
          {title && (
            <RichText className={cx(css.title, titleStyle)} render={title} />
          )}
          <div className={css.boxContentInfosBottom}>
            {primaryCta && <Cta className={css.cta} {...primaryCta} />}
            {secondaryCta && <Cta className={css.cta} {...secondaryCta} />}
          </div>
        </div>
      </div>
    </div>
  )
}

BoxDoubleImage.defaultProps = {}

export default BoxDoubleImage
